// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2QmAw","subheader":"ReorderModal_subheader__3S82e","listWrap":"ReorderModal_listWrap__3KyDN"};